import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58979163"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "home-content" }
const _hoisted_5 = { class: "home-left" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, "SagaCare", -1))
const _hoisted_9 = { class: "home-right" }
const _hoisted_10 = {
  key: 0,
  class: "box"
}
const _hoisted_11 = { class: "qrcode-main" }
const _hoisted_12 = {
  key: 0,
  class: "qrcode-model"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qrcode-text" }, " 请使用朵朵小程序,扫描上面二维码进行授权登录 ", -1))
const _hoisted_15 = {
  key: 1,
  class: "box"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 提交 ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fotter" }, "欢迎使用智能办公", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_ctx.showLogin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "home-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkLoginType && _ctx.checkLoginType(...args)))
        }, [
          (_ctx.type === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "二维码登录"))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "账号登录"))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.parseImgUrl('ipdImages', 'logo.svg'),
                alt: ""
              }, null, 8, _hoisted_7),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_qrcode_vue, {
                      value: _ctx.codeValue,
                      class: "qrcode",
                      foreground: "#CE9F27",
                      level: "H"
                    }, null, 8, ["value"]),
                    (_ctx.codeStatus.status)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_ctx.codeStatus.status === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已扫描"))
                            : _createCommentVNode("", true),
                          (_ctx.codeStatus.status === 2 || _ctx.codeStatus.status === 3)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 1,
                                class: "code-replay",
                                onClick: _ctx.refreshCode,
                                name: "replay"
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_14
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_van_form, {
                    onSubmit: _ctx.onSubmit,
                    class: "box-form"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_cell_group, { inset: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_field, {
                            modelValue: _ctx.username,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
                            name: "username",
                            placeholder: "用户名",
                            rules: [{ required: true, message: '请填写用户名' }]
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_van_field, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                            type: "password",
                            name: "password",
                            placeholder: "密码",
                            rules: [{ required: true, message: '请填写密码' }]
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", null, [
                        _createVNode(_component_van_button, {
                          round: "",
                          block: "",
                          "native-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
          ])
        ]),
        _hoisted_17
      ]))
    : _createCommentVNode("", true)
}